import { render, staticRenderFns } from "./BedrockInteraction.vue?vue&type=template&id=c8d5a508&scoped=true&"
import script from "./BedrockInteraction.vue?vue&type=script&lang=js&"
export * from "./BedrockInteraction.vue?vue&type=script&lang=js&"
import style0 from "./BedrockInteraction.vue?vue&type=style&index=0&id=c8d5a508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d5a508",
  null
  
)

export default component.exports